import { selectPlaceholderNode } from '@newStore/documentUI/transformContent/genericSelectors';
import { type BuildingBlockNodeConfig, NodeType } from '@nodeTypeConfig/configTypes';

const LLINKID_GOAL_DEMARCATION: BuildingBlockNodeConfig = {
  nodeSelector: selectPlaceholderNode,
  information: {
    single: 'Afbakening',
    plural: 'Afbakening',
  },

  buildingBlocks: [{ type: NodeType.SECTION }, { type: NodeType.PARAGRAPH }],
  edit: [],
  readOnlyNode: true,

  isCollapsible: true,
  showPlaceholder: true,
  onNewNodeDropped: {
    openAside: false,
  },
};

export default LLINKID_GOAL_DEMARCATION;
